import { render } from "./NotesMain.vue?vue&type=template&id=62e4f404"
import script from "./NotesMain.vue?vue&type=script&lang=js"
export * from "./NotesMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__